var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Route',{staticClass:"Card CardQA",attrs:{"to":{ name: 'FaqLandowners', hash: `#Qa-${_vm.number}` }}},[_c('div',{staticClass:"body"},[_c('h5',[_vm._v(_vm._s(_vm.question))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }